import { useHospitalData } from './useHospitalData';
import { useHospitalActions } from './useHospitalActions';
import { useHospitalUI } from './useHospitalUI';

export const useHospitalSimilarity = () => {
  const {
    hospitals,
    filters,
    currentPage,
    totalPages,
    loading,
    statusCounts,
    setFilters,
    setCurrentPage,
    loadHospitals,
    loadStats
  } = useHospitalData();

  const {
    expandedCards,
    selectedMatches,
    toggleCardExpansion,
    updateFilters,
    changePage,
    setSelectedMatch,
    setSelectedMatches
  } = useHospitalUI(setFilters, setCurrentPage, currentPage, totalPages);

  const {
    updateHospitalStatus,
    updateHospitalField,
    reprocessHospital
  } = useHospitalActions(hospitals, selectedMatches, setSelectedMatches, loadHospitals, loadStats);

  return {
    hospitals,
    statusCounts,
    filters,
    currentPage,
    totalPages,
    loading,
    expandedCards,
    selectedMatches,
    updateHospitalStatus,
    updateHospitalField,
    reprocessHospital,
    toggleCardExpansion,
    updateFilters,
    changePage,
    setSelectedMatch
  };
};